export default "__VITE_ASSET__3e0facee__"